module.exports = __webpack_public_path__ + "img/wechatAcc.d776b92d.png";